import React, { useEffect, useState } from "react";
import { useStoreActions } from "easy-peasy";
import { Link, Redirect } from "react-router-dom";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
// import { Card } from "@material-ui/core";

const Activate = (props) => {
  const activate = useStoreActions((actions) => actions.auth.activate);
  const [activated, setActivated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const email = params.get("email");

    if (email && token) {
      setEmail(email);
      activate({ token, email }).then(
        (res) => {
          setActivated(true);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          switch (err.response.status) {
            case 405:
              //account already activated
              setActivated(true);
              console.log(err.response);
              break;
            default:
              console.log(err.response);
              setError(true);
              break;
          }
        }
      );
      console.log({ token, email });
    } else {
      setLoading(false);
      setError(true);
    }
  }, [activate]);
  return (
    <>
      {loading && (
        <Row>
          <Spinner className="global-spinner" />
        </Row>
      )}
      {activated && (
        <Redirect to={{ pathname: "/login", state: { email: email } }} />
      )}
      {error && (
        <Row className="mt-2">
          <Col xs={12}>
            <Card>
              <CardBody>
                <h2 className="font-weight-bold text-dark">
                  Problem Activating
                </h2>
                <p>
                  Return to <Link to="/home">Home</Link>
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Activate;
